import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

const BarChartComp = ({ chartData }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

  const options = {
    indexAxis: 'x',
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Bar Chart',
        position: 'bottom',
      },
    },
  };

  const data = {
    labels: chartData.map((item) => item.date),
    datasets: [
      {
        label: 'Credits',
        data: chartData.map((item) => item.credits),
        backgroundColor: '#7FB04F',
        barPercentage: 0.4,      
        categoryPercentage: 0.6,   
      },
    ],
  };


  return (
    <>
      <div className='w-full'>
      <Bar options={options} data={data} />
      </div>
    </>
  );
};

export default BarChartComp;
